import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import $ from "jquery";
import { Space, Table, Tag, Progress } from "antd";
import "./myStudies.css";
import Bridge from "../../constants/Bridge";
const MyStudiesDashboard = () => {
  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    fetchDashboardData();

  }, []);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [totalRapaEnrolled, setTotalRapaEnrolled] = useState();
  const [totalStudyCompleted, setTotalStudyCompleted] = useState();
  const [totalEalsConsented, setTotalEalsConsented] = useState();
  const [totalWithdrawn, setTotalWithdrawn] = useState();
  const [totalBaseline, setTotalBaseline] = useState();
  const [totalCompliance, setTotalCompliance] = useState(0);


  const columns = [
    {
      title: "Site",
      dataIndex: "site",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Participant Id",
      dataIndex: "participant_id",
      key: "participant_id",
    },
    {
      title: "Last Visit",
      dataIndex: "last_visit",
      key: "last_visit",
    },
    {
      title: "Next Visit",
      dataIndex: "next_visit",
      key: "next_visit",
    },
    {
      title: "Average FVC",
      dataIndex: "average_fvc",
      key: "average_fvc",
    }, {
      title: "Average SVC",
      dataIndex: "average_svc",
      key: "average_svc",
    },
  ];

  // Table data with address included
  const data = [
    {
      key: "1",
      site: "John Brown",
      participant_id: 32,
      last_visit: "2024-01-01",
      next_visit: "2024-01-01",
      average_fvc: "2024-01-01",
      average_svc: "2024-01-01",
      progress: 50,
    },
    {
      key: "2",
      site: "Jim Green",
      participant_id: 42,
      last_visit: "2024-01-01",
      next_visit: "2024-01-01",
      average_fvc: "2024-01-01",
      average_svc: "2024-01-01",
      progress: 23,
    },
    {
      key: "3",
      site: "Joe Black",
      participant_id: 32,
      last_visit: "2024-01-01",
      next_visit: "2024-01-01",
      average_fvc: "2024-01-01",
      average_svc: "2024-01-01",
      progress: 78,
    },
  ];
  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const data = await Bridge.myStudies.getDashboardData();
      console.log("API Data:", data.result); // Debugging: Check API Response
      setTotalRapaEnrolled(data.
        total_rapa_participants_enrolled
      );
      setTotalStudyCompleted(data.total_rapa_stydy_complete
      );
      setTotalEalsConsented(data.total_rapa_enrolled_remote_monitoring);
      setTotalWithdrawn(data.total_rapa_withdrawn_remote_monitoring);
      setTotalBaseline(data.total_completed_baseline);
      setTotalCompliance(data.compliance_rate);
      if (data && data.result) {
        const tableData = data.result
          .map(item => ({
            key: item.participants_id,
            site: item.site == "" ? "-" : item.site,
            participant_id: item.rapa_id,
            last_visit: item.lastSession,
            next_visit: item.nextSession,
            average_fvc: item.averageFVC,
            average_svc: item.averageSVC,
            progress: item.completion_percentage, // Ensure progress is set
          }))
          .filter(item => {
            // Exclude rows where all values are empty or "-"
            return !(
              (item.site === "" || item.site === "-") &&
              (item.participant_id === "" || item.participant_id === "-") &&
              (item.last_visit === "" || item.last_visit === "-") &&
              (item.next_visit === "" || item.next_visit === "-") &&
              (item.average_fvc === "" || item.average_fvc === "-") &&
              (item.average_svc === "" || item.average_svc === "-")
            );
          });

        setTableData(tableData);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
    setLoading(false);
  };

  return (
    <div className="participant-activity-div radcliff-participant-page">
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-lg-10 participant-right-section-wrapper">
          <div className="row">
            <div className="inner-wrapper">
              <div className="row top-space">
                <div className="col-lg-1"></div>
                <div className="col-lg-11">
                  <div className="ambassador-heading-section mb-3">
                    <h3
                      style={{
                        position: "relative",
                        fontSize: 28,
                        fontFamily: "Open Sans",
                        fontWeight: "bold",
                        color: "#1A4F83",
                        textAlign: "start",
                        marginLeft: "10px",
                      }}
                      className="mb-3"
                    >
                      My Studies Dashboard{" "}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="row align-items-center justify-content-around">
                  <div className="col-lg-1"></div>
                  <div className="col-lg-3 filter-by-activity-input-wrapper">
                    <div className="filter-by-activity-input">
                      <h6>Total RAPA <br />Participants Enrolled</h6>
                      <div className="rapa-count">
                        <h6>{totalRapaEnrolled}</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-12 col-sm-12 col-lg-3 filter-by-independant-coach-input"
                    style={{ marginBottom: "7px", marginLeft: "15px" }}
                  >
                    <h6>
                      Total Consented to EALS <br /> Remote Monitoring
                    </h6>
                    <div className="rapa-count">
                      <h6>{totalEalsConsented}</h6>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-lg-4 filter-by-column-input-wrapper">
                    <h6>
                      Total RAPA Participants Withdrawn <br /> from EALS Remote Monitoring
                    </h6>
                    <div className="rapa-count">
                      <h6>{totalWithdrawn}</h6>
                    </div>{" "}
                  </div>
                  <div></div>
                </div>
                {/* second div */}
                <div className="mt-4 row align-items-center justify-content-around">
                  <div className="col-lg-1"></div>
                  <div className="col-lg-3 filter-by-activity-input-wrapper">
                    <div className="filter-by-activity-input">
                      <h6>Completed Baseline %</h6>
                      <div className="rapa-count">
                        <h6>{totalBaseline}</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-12 col-sm-12 col-lg-3 filter-by-independant-coach-input"
                    style={{ marginBottom: "7px", marginLeft: "15px" }}
                  >
                    <h6>Compliance Rate</h6>
                    <div className="rapa-count">
                      <h6>{totalCompliance.toFixed(2)}</h6>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-lg-4 filter-by-column-input-wrapper">
                    <h6>Completed the Study</h6>
                    <div className="rapa-count">
                      <h6>{totalStudyCompleted}</h6>
                    </div>
                  </div>
                  <div></div>
                </div>
                <div className="row participant-activity-table">
                  <div
                    className="col-lg-11 mt-3"
                    style={{ marginLeft: "auto" }}
                  >
                    <Table
                      columns={columns}
                      dataSource={tableData}
                      rowKey="key"
                      pagination={true}
                      loading={loading}

                      components={{
                        body: {
                          row: ({ children, ...rest }) => {
                            const mainRow = <tr {...rest}>{children}</tr>;
                            const record = tableData.find((item) => item.key === rest["data-row-key"]);

                            if (!record) return mainRow;

                            return (
                              <>
                                {mainRow}
                                {record.progress !== undefined && record.progress !== null && (
                                  <tr className="address-row">
                                    <td colSpan={columns.length} className="address-cell">
                                      <label>Study Progress</label>
                                      <Progress strokeColor="green" percent={parseFloat(record.progress || 0).toFixed(2)} />
                                    </td>
                                  </tr>
                                )}
                              </>
                            );
                          },
                        },
                      }}

                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyStudiesDashboard;
{
  /* <div className="col-12 col-sm-12 col-lg-4 filter-by-column-input-wrapper">
<h5>Completed Baseline %</h5>
</div>
<div className="col-12 col-sm-12 col-lg-4 filter-by-column-input-wrapper">
<h5>Compliance Rate</h5>
</div>
<div className="col-12 col-sm-12 col-lg-4 filter-by-column-input-wrapper">
<h5>Completed the Study</h5>
</div> */
}
